module.exports = __webpack_public_path__ + "714d1724a2b3323651e3a4d380f644d6.svg";